import ConsultationsResults from './views/Result.vue';
import BatchResults from './views/ResultBatch.vue';
import LegalPersonCreate from './views/legal-person/Create.vue';
import OthersCreate from './views/others/Create.vue';
import PhysicalPersonCreate from './views/physical-person/Create.vue';
import PropertiesCreate from './views/properties/Create.vue';
import VehiclesCreate from './views/vehicles/Create.vue';

const routes = [
  {
    path: '/compliance/physical-person/create',
    name: 'Compliance-Physical-Person-Create',
    component: PhysicalPersonCreate,
  },
  {
    path: '/results',
    name: 'Consultations-Results',
    component: ConsultationsResults,
  },
  {
    path: '/batch-results',
    name: 'Consultations-Results-Batch',
    component: BatchResults,
  },
  {
    path: '/compliance/legal-person/create',
    name: 'Compliance-Legal-Person-Create',
    component: LegalPersonCreate,
  },
  {
    path: '/compliance/vehicles/create',
    name: 'Compliance-Vehicles-Create',
    component: VehiclesCreate,
  },
  {
    path: '/compliance/others/create',
    name: 'Compliance-Others-Create',
    component: OthersCreate,
  },
  {
    path: '/compliance/properties/create',
    name: 'Compliance-Properties-Create',
    component: PropertiesCreate,
  },
];

export default routes;
